<m-fade-in-up>
  @if (isLoading()) {
    <m-skeleton height="280px" class="w-full"></m-skeleton>
  } @else if (!isDataAvailable() && !returnCurveIsReady()) {
    <m-not-available
      height="280px"
      description="We don't have a summary ready for you now"></m-not-available>
  } @else {
    <m-card class="w-full" [noShadow]="true" [variant]="cardVariant.compact">
      <div class="w-full grid grid-cols-12 gap-6">
        <div class="col-span-6">
          @if (topMetric()) {
            <m-card [variant]="cardVariant.small">
              <div class="grid grid-cols-12 gap-6 items-center">
                <div class="text-center col-span-4">
                  <div class="max-w-[200px] m-auto">
                    <img
                      class="max-w-full"
                      [src]="'assets/images/taxes.svg'"
                      alt="Metric" />
                  </div>
                </div>
                <div class="col-span-8 flex flex-col gap-1">
                  <div class="sh2 text-gray-1000 mb-1">
                    {{ topMetric().label }}
                    <span
                      class="ml-1"
                      [ngClass]="
                        topMetric().isChangePositive
                          ? 'text-green-700'
                          : 'text-orange-300'
                      "
                      >{{ topMetric().formattedValue }}</span
                    >
                  </div>
                  <div class="c1 text-gray-800 mb-[16px]">
                    Comparison period: {{ comparisonPeriod() }}
                  </div>
                  <div class="c1 text-gray-1000 mb-2">
                    Drivers for {{ topMetric().label }}:
                  </div>
                  <portal-context-driver-display
                    [column]="columnType.one"
                    [drivers]="drivers()"
                    [isSpendLevel]="isSpendLevel()"
                    [viewType]="'tactic'"></portal-context-driver-display>
                </div>
              </div>
            </m-card>
          } @else {
            <m-not-available
              height="280px"
              description="We don't have a summary for you now"></m-not-available>
          }
        </div>
        <div class="col-span-6">
          <p-card>
            <div class="flex justify-between items-center mb-2">
              <h4 class="sh1 m-0 flex justify-between items-center">
                Return Curve
                <span
                  class="material-symbols-outlined text-blue-500 icon-small ml-2"
                  [pTooltip]="returnCurveTooltip"
                  tooltipPosition="top"
                  [escape]="false"
                  tooltipStyleClass="saas-tooltip"
                  >info</span
                >
              </h4>
              <m-dropdown
                [options]="metricOptions"
                [ngModel]="selectedMetricType()"
                (formControlChange)="onMetricTypeChange($event?.value)"
                optionLabel="label"
                optionValue="value"
                styleClass="w-50 float-right"
                data-testid="metric-type-context-menu-dropdown">
              </m-dropdown>
            </div>
            <div class="w-full">
              @if (
                !returnCurveIsLoading() &&
                returnCurveIsReady() &&
                returnCurveValid()
              ) {
                <m-line-chart
                  height="280px"
                  [options]="returnCurveChartOptions()"
                  (chartRender)="onChartRender($event)"
                  class="w-full">
                </m-line-chart>
              } @else {
                <m-not-available
                  height="280px"
                  description="We don't have a return curve ready for you now"></m-not-available>
              }
            </div>
          </p-card>
        </div>
      </div>
    </m-card>
  }
</m-fade-in-up>
